<template>
  <v-alert style="margin: 0px; padding: 5px;" v-if="alertType" type="alertType" :value="true">
    {{value}}
  </v-alert>
  <v-alert style="margin: 0px; padding: 5px;" v-else-if="color" :color="color" :value="true">
    {{value}}
  </v-alert>
  <span v-else> {{value}}</span>


  <!-- <v-alert style="margin: 0px; padding: 5px;" v-if="alertType || color" :color="color" :type="alertType" :value="true"> -->

  </v-alert>
</template>

<style scoped>

</style>

<script>
  import TextCell from "./textCell.ts";
  export default TextCell;
</script>